/* eslint-disable pii/no-email */
// cspell:disable
export const EmailInfoMock = {
  actionId: 654321,
  shippingElementId: 323543,
  touchRules: {
    isTouchRules: true,
    days: 2,
    emails: 1,
  },
  sender: {
    id: 876543,
    nameFrom: 'Emblue',
    emailFrom: 'sender@embluemail.com',
    emailReply: 'sender2@embluemail.com',
  },
  emailInfo: {
    subject: '',
    firstLine: '',
  },
  content: {
    editorVersion: 'beefree',
    originId: 8,
    message: '',
    header: '',
    footer: '',
    mobile: {
      header: '',
      footer: '',
      body: '',
    },
    errors: [],
  },
  groupsAndLists: [
    {
      id: 1,
      name: 'Emblue test',
      type: 2,
    },
    {
      id: 2,
      name: 'testsin info',
      type: 2,
    },
    {
      id: 3,
      name: 'Grupo Test',
      type: 2,
    },
  ],
};

export const AddresseesInfoMock = {
  isImmediateShipping: true,
  shippingDate: '2024-02-27T18:37:07.000Z',
  reinforcement: {
    isReinforcementShipment: false,
  },
};

export const AddresseesListMock = [
  {
    groupId: 2,
    name: 'Test group',
    contactCount: '12',
    rank: 3,
    type: 'user',
  },
];

export const EmailPreviewMock = {
  subject: 'ActionForEmailTest Mock',
  content: {
    editorVersion: 'beefree',
    footer:
      '<table class="tabla_general_emblue_001"  align="center" cellspacing="0" cellpadding="0" style="font-family:Helvetica, Arial; font-size: 11px; color:#7c7c7c; font-weight:lighter; line-height:15px;width:100%;max-width: 700px;min-width: 350px;">\n\n\n\t<tr>\n\t\t<td style="padding: 10px 0 5px 0;  border-bottom: 1px solid #cccccc; ">\n\t\t\t<p align="center">En virtud de lo establecido por la disposici&oacute;n de Protecci&oacute;n de Datos Personales usted tiene derecho a solicitar al emisor de este mensaje la rectificaci&oacute;n, actualizaci&oacute;n, inclusi&oacute;n o supresi&oacute;n de los datos personales incluidos en su base de contactos, listas o cadenas de mensajes en los cuales usted se encuentre. <a href="http://embluemail.com/terminos-y-condiciones.html" alt="Conozca m&aacute;s" style="font-weight:normal; text-decoration: none; color:#444;">Conozca m&aacute;s</a></p>\n\t\t</td>\n\t</tr>\n\n\n\t<tr>\n\t\t<td style="padding: 10px 0 5px 0;">\n\t\t\t<p align="center">Este mensaje fue enviado por <span style="font-weight:normal; color:#444;">EMBLUE - Daniela Merchan</span>  (defaultsender@mailingmktg.com) a <span style="font-weight:normal; color:#444;">${0#email}</span> a trav&eacute;s de emBlue marketing cloud. <span><a style="font-weight:normal; color:#444; text-decoration: underline;" href="https://app.embluemail.com/Services/Interaccion.svc/GetvCard?data=82428-40656" alt="Agregar a mis contactos">Agregar a mis contactos</a></span><br />\n- CP - &bull; -, - &bull; -<br>\n\t\t\t</p>\t\n\t\t</td>\n\t</tr>\n\n    \n\t<tr>\n\t\t<td style="padding: 10px 0 5px 0; color:#bbbbbb; text-decoration: none;">\n            <p align="center">\n                <span><a class="link_emblue_001" style="color:#2d83af; text-decoration: none;" href="%desuscribirurl%" alt="Desuscribirme">Quiero desuscribirme</a></span>\n                | \n                <span><a class="link_emblue_001" style="color:#2d83af; text-decoration: none;" href="$FE{legal}" alt="GDPR Compliance">T&eacute;rminos y condiciones</a></span>\n            </p>\n\t\t</td>\n\t</tr>\n    \n    \n    \n    <tr>\n        <td>\n            <p align="center">\n                <span>Sender validado por</span>\n            </p>\n        </td>\n    </tr>    \n    \n    <tr>\n        <td>\n            <p align="center">\n                <img src="https://i.embluejet.com/ImagenesMoxie/emblue/images/logo.jpg" width="120" height="35" alt="Trusted Sender" />\n            </p>\n        </td>\n    </tr>\n    \n</table>',
    header:
      '<!--[if gte mso 9]><xml>\n     <o:OfficeDocumentSettings>\n      <o:AllowPNG/>\n      <o:PixelsPerInch>96</o:PixelsPerInch>\n     </o:OfficeDocumentSettings>\n</xml><![endif]-->\n<style type="text/css" id="media-query">\n</style>\n\n<table class="tabla_general_emblue_001" align="center" cellspacing="0" cellpadding="0">\n    <tr>\n        <td>\n        <table cellpadding="0" cellspacing="0" width="100" class="textclass" align="center" style="font-family:Helvetica, Arial; font-size: 12px; color:#7c7c7c; font-weight:lighter; line-height:15px;width:100%;max-width: 700px;min-width: 350px;">\n            <tr>\n                <td style="text-align: center;">ActionForEmailTest</td>\n            </tr>\n        </table>\n        </td>\n    </tr>\n</table>\n\n\n<table class="tabla_general_emblue_001" align="center" cellspacing="0" cellpadding="0" style="font-family:Helvetica, Arial; font-size: 12px; color:#7c7c7c; font-weight:lighter; line-height:15px;width:100%;max-width: 700px;min-width: 350px;">\n\t<tr><td align="center" style="padding-top: 10px;"><p align="center" style="margin-bottom: 15px;color: #7c7c7c;">\n\t<span><a class="link_emblue_001" style="color:#7c7c7c; text-decoration: none;" href="%onlineurl%" target="_blank" alt="Ver en mi navegador">Ver en mi navegador</a></span>\n\t</p>\n</td></tr>\n</table>\n',
    message:
      '<head>   </head><body>   ActionForEmailTest Mock<br>Nombre: Pepita - <br>Telefono: 123456<br>Estado civil:  <br><br></body>',
  },
  sender: {
    id: 82428,
    nameFrom: 'sender',
    emailFrom: 'defaultsender@mailingmktg.com',
    emailReply: 'defaultsender2@mailingmktg.com',
  },
};
